/**
 * API Base URL Configuration
 * Provides consistent API base URL across all services
 */

/**
 * Get the correct API base URL for the current environment
 * Always uses unified backend (localhost:8000) in development
 */
export const getApiBaseUrl = (): string => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  // For development (localhost), always use unified backend on port 8000
  if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    return `${protocol}//localhost:8000`;
  }
  
  // For production, use the same domain
  return `${protocol}//${hostname}`;
};

// Export as constant for convenience
export const API_BASE_URL = getApiBaseUrl();

export default API_BASE_URL;